import { ReactNode } from 'react';
import AuthGuard from '@/components/feature/AuthGuard';
import AdminSidebar from './AdminSidebar';

export default function AdminLayout({ children }: { children: ReactNode }) {
  return (
    <AuthGuard>
      <div className="min-h-screen bg-background-50">
        <AdminSidebar />
        <main className="lg:ml-[240px] min-h-screen pb-20 lg:pb-8">
          {children}
        </main>
      </div>
    </AuthGuard>
  );
}